import { useShopSettings } from "@/context/ShopSettingsContext";
import { TikTokShopButton } from "./TikTokShopButton";

export const PrelaunchBanner = () => {
  const { showcase_mode } = useShopSettings();
  if (!showcase_mode) return null;
  return (
    <div data-testid="prelaunch-banner" className="border-b border-white/10 bg-[#120a1f]">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-2 px-3 py-2 text-center sm:flex-row sm:justify-center sm:gap-4 sm:px-6">
        <p data-testid="prelaunch-banner-text" className="text-[11px] leading-snug text-white/85 sm:text-sm">
          <span className="font-extrabold text-[#FFD60A]">Benvenuto su MC Anime!</span> Il nostro e-commerce ufficiale aprirà a breve.
          Nel frattempo, puoi acquistare in sicurezza tutti i nostri prodotti e novità direttamente sul nostro TikTok Shop ufficiale!
        </p>
        <TikTokShopButton size="sm" label="Vai allo Shop TikTok" className="shrink-0" testId="prelaunch-banner-tiktok-button" placement="banner" />
      </div>
    </div>
  );
};
